import React , {useState} from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Stack, Chip , TextField , ListSubheader } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultiSelectInput({
  register,
  array,
  required,
  inputName = "sendTo",
}) {
  const [selectedNames, setSelectedNames] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const handleChange = (event) => {
    setSelectedNames(event.target.value);
  };

  const filteredArray = array.filter((item) =>
    item.desc.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    // <Select
    //   {...register(inputName, {
    //     required: { value: required, message: "sendTo is required" },
    //   })}
    //   multiple
    //   className="mt-1 w-100"
    //   value={selectedNames}
    //   onChange={handleChange}
    //   input={<OutlinedInput />}
    //   renderValue={(selected) => {
    //     return (
    //       <Stack gap={1} direction="row" flexWrap="wrap">
    //         {selected.map((value) => {
    //           return (
    //             <Chip
    //               key={value.value}
    //               sx={{
    //                 background: "#E65B69",
    //                 color: "#F5F5F5",
    //               }}
    //               label={value?.desc}
    //               onDelete={() =>
    //                 setSelectedNames(
    //                   selectedNames.filter(
    //                     (item) => item !== value
    //                   )
    //                 )
    //               }
    //               deleteIcon={
    //                 <CloseIcon
    //                   style={{ color: "white" }}
    //                   onMouseDown={(event) =>
    //                     event.stopPropagation()
    //                   }
    //                 />
    //               }
    //             />
    //           );
    //         })}
    //       </Stack>
    //     );
    //   }}
    // >
    //   {array.map((item) => (
    //     <MenuItem key={item.value} value={item}>
    //       {item.desc}
    //     </MenuItem>
    //   ))}
    // </Select>
    <Select
      {...register(inputName, {
        required: { value: required, message: "sendTo is required" },
      })}
      multiple
      className="mt-1 w-100"
      value={selectedNames}
      onChange={handleChange}
      input={<OutlinedInput />}
      renderValue={(selected) => (
        <Stack gap={1} direction="row" flexWrap="wrap">
          {selected.map((value) => (
            <Chip
              key={value.value}
              sx={{
                background: "#E65B69",
                color: "#F5F5F5",
              }}
              label={value?.desc}
              onDelete={() =>
                setSelectedNames(
                  selectedNames.filter((item) => item !== value)
                )
              }
              deleteIcon={
                <CloseIcon
                  style={{ color: "white" }}
                  onMouseDown={(event) => event.stopPropagation()}
                />
              }
            />
          ))}
        </Stack>
      )}
      MenuProps={{
        PaperProps: {
          style: { maxHeight: 300 },
        },
        disableAutoFocusItem: true, 
      }}
    >
      <ListSubheader>
        <TextField
          size="small"
          autoFocus
          placeholder="Search..."
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </ListSubheader>

      {filteredArray.length > 0 ? (
        filteredArray.map((item) => (
          <MenuItem key={item.value} value={item}>
            {item.desc}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>No results</MenuItem>
      )}
    </Select>
  );
}
